import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: "#DADADA",
    marginTop: theme.spacing(7),
  },
  controlGroupRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3, 0),
    borderBottom: "1px solid #DADADA",
    [theme.breakpoints.down("md")]: {
      justifyContent: "flex-start",
      gap: theme.spacing(7),
    },
  },
  controlGroup: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      minWidth: 140,
      alignSelf: "stretch",
      justifyContent: "flex-start",
    },
  },
  controlGroupLabel: {
    fontSize: "0.88rem",
    fontWeight: 500,
    [theme.breakpoints.down("xl")]: {
      fontSize: "0.75rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.63rem",
    },
  },
  button: {
    width: 135,
    height: 34,
    fontSize: "0.88rem",
    borderRadius: 5,
    [theme.breakpoints.up("lg")]: {
      width: 185,
      height: 46,
      fontSize: "1rem",
      borderRadius: 10,
    },
  },
  bottomGroupMobile: {
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: theme.spacing(2.5),
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
  },
  promotionalText: {
    fontSize: "0.63rem",
    fontWeight: 500,
  },
}));
